<div class="header-bar">
  <h1>Fuel Price Adjuster</h1>
</div>

<p-tabView (onChange)="changeTab($event)" class="hideTabPanel">
  <p-tabPanel header="Prices"></p-tabPanel>
  <p-tabPanel header="Price Settings"></p-tabPanel>
  <p-tabPanel header="Configuration"></p-tabPanel>
</p-tabView>

<div *ngIf="loading" class="flex justify-content-center my-4">
  <i class="fa fa-spin fa-spinner fa-3x"></i>
</div>

<div *ngIf="tab == 0" class="content-container">
  <div *ngIf="!loading" class="flex flex-column px-4 py-4 gap-4">
    <div>
      <span class="text-2xl bold-text">Current Fuel Prices </span>
      <i
        class="fa fa-circle"
        [ngClass]="{ 'text-green-500': isEnabled, 'text-red-500': !isEnabled }"
      ></i>
      <span
        *ngIf="fuelPriceAdjusterCurrentPrice?.effectiveDate != null"
        class="text-sm text-gray-500 font-italic"
      >
        - effective from:
        {{ fuelPriceAdjusterCurrentPrice?.effectiveDate | date : 'dd MMM yyyy HH:mm' }}</span
      >
      <button
        pButton
        type="button"
        [label]="isEnabled ? 'Disable' : 'Enable'"
        class="ui-button ui-button-default btn-to-right pull-right m-0"
        (click)="changeFuelPriceAdjusterStatus()"
      ></button>
      <button
        pButton
        type="button"
        label="Add Fuel Prices"
        class="ui-button ui-button-default btn-to-right pull-right m-0 mr-2"
        (click)="openAddFuelPricesDialog()"
      ></button>
    </div>
    <div class="flex flex-row gap-6 justify-content-center">
      <p-card class="w-3">
        <div class="flex flex-row gap-2 p-2 h-5rem">
          <div class="w-3">
            <svg
              class="w-4rem h-4rem text-blue-700 flex-none"
              viewBox="0 -960 960 960"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                d="M160-120v-640q0-33 23.5-56.5T240-840h240q33 0 56.5 23.5T560-760v280h40q33 0 56.5 23.5T680-400v180q0 17 11.5 28.5T720-180q17 0 28.5-11.5T760-220v-288q-9
              5-19 6.5t-21 1.5q-42 0-71-29t-29-71q0-32 17.5-57.5T684-694l-84-84 42-42 148 144q15 15 22.5 35t7.5 41v380q0 42-29 71t-71 29q-42 0-71-29t-29-71v-200h-60v300H160Zm80-440h240v-200H240v200Zm480
              0q17 0 28.5-11.5T760-600q0-17-11.5-28.5T720-640q-17 0-28.5 11.5T680-600q0 17 11.5 28.5T720-560ZM240-200h240v-280H240v280Zm240 0H240h240Z"
              />
            </svg>
          </div>
          <div class="w-9 flex flex-column gap-2 pt-2">
            <span class="flex-shrink-1">
              <span class="font-bold text-base text-blue-600">Diesel - </span>
            </span>
            <span class="flex-grow-1">
              <span class="font-bold text-4xl text-blue-700">{{
                (fuelPriceAdjusterCurrentPrice?.dieselPrice | number : '1.2-2') || '---.--'
              }}</span>
              <span> p / Litre </span>
            </span>
          </div>
        </div>
      </p-card>
      <p-card class="w-3">
        <div class="flex flex-row gap-2 p-2 h-5rem">
          <div class="w-3">
            <svg
              class="w-4rem h-4rem text-green-700 flex-none"
              viewBox="0 -960 960 960"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                d="M160-120v-640q0-33 23.5-56.5T240-840h240q33 0 56.5 23.5T560-760v280h40q33 0 56.5 23.5T680-400v180q0 17 11.5 28.5T720-180q17 0 28.5-11.5T760-220v-288q-9
                5-19 6.5t-21 1.5q-42 0-71-29t-29-71q0-32 17.5-57.5T684-694l-84-84 42-42 148 144q15 15 22.5 35t7.5 41v380q0 42-29 71t-71 29q-42 0-71-29t-29-71v-200h-60v300H160Zm80-440h240v-200H240v200Zm480
                0q17 0 28.5-11.5T760-600q0-17-11.5-28.5T720-640q-17 0-28.5 11.5T680-600q0 17 11.5 28.5T720-560ZM240-200h240v-280H240v280Zm240 0H240h240Z"
              />
            </svg>
          </div>
          <div class="w-9 flex flex-column gap-2 pt-2">
            <span class="flex-shrink-1">
              <span class="font-bold text-base text-green-600">Petrol - </span>
            </span>
            <span class="flex-grow-1">
              <span class="font-bold text-4xl text-green-700">{{
                (fuelPriceAdjusterCurrentPrice?.petrolPrice | number : '1.2-2') || '---.--'
              }}</span>
              <span> p / Litre </span>
            </span>
          </div>
        </div>
      </p-card>
    </div>
    <div class="flex flex-column gap-2">
      <span class="text-2xl bold-text mb-2">Fuel Price Adjuster Price History</span>
      <p-table
        [value]="fuelPriceAdjusterPrices"
        [paginator]="true"
        [loading]="loadingSettings"
        [totalRecords]="fuelPriceAdjusterPrices?.length"
        [rowsPerPageOptions]="[10, 20, 50]"
        [rows]="10"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>Diesel Price (p)</th>
            <th>Petrol Price (p)</th>
            <th pSortableColumn="effectiveDate">Effective Date</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr>
            <td>{{ item.dieselPrice | number : '1.2-2' }}</td>
            <td>{{ item.petrolPrice | number : '1.2-2' }}</td>
            <td>{{ item.effectiveDate | datex : 'ddd DD MMM YY HH:mm' }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
<div *ngIf="tab == 1" class="content-container">
  <div *ngIf="!loading" class="flex flex-column px-4 py-4 gap-4">
    <div class="flex flex-column gap-2">
      <span class="text-2xl bold-text mb-2">Fuel Price Adjuster Settings</span>
      <p-table
        [value]="fuelPriceAdjusterSettings"
        [paginator]="false"
        selectionMode="single"
        [loading]="loadingSettings"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>Fuel Type</th>
            <th>Current Price (p)</th>
            <th>Base Price (p)</th>
            <th>Upper Threshold (p)</th>
            <th>Lower Threshold (p)</th>
            <th>Banding Increment (p)</th>
            <th>Status</th>
            <th>Trigger Status</th>
            <th>Surcharge per Mile (£)</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr>
            <td>{{ item.fuelType }}</td>
            <td>{{ getCurrentPrice(item) | number : '1.2-2' }}</td>
            <td>{{ item.basePrice | number : '1.2-2' }}</td>
            <td>{{ item.upperThreshold | number : '1.2-2' }}</td>
            <td>{{ item.lowerThreshold | number : '1.2-2' }}</td>
            <td>{{ item.bandingIncrement | number : '1.2-2' }}</td>
            <td>
              {{ item.isActive ? 'Enabled' : 'Disabled' }}
            </td>
            <td>
              <div [class.bold-text]="item.isTriggered">
                {{ isFuelPriceAdjusterSettingTriggered(item) ? 'Triggered' : 'Not Triggered' }}
                <i
                  *ngIf="item.isTriggered"
                  class="pi pi-exclamation-triangle"
                  style="transform: scale(1.5)"
                ></i>
              </div>
            </td>
            <td>
              {{ getSurchargePerMile(item) | number : '1.2-2' }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div class="flex flex-column gap-2">
      <span class="text-2xl bold-text mb-2">Fuel Price Adjuster Bandings</span>
      <div class="flex flex-row gap-2">
        <span class="flex flex-grow-1 justify-content-center text-xl bold-text mb-2">Diesel</span>
        <span class="flex flex-grow-1 justify-content-center text-xl bold-text mb-2">Petrol</span>
      </div>
      <div class="flex flex-row gap-2">
        <span class="flex flex-grow-1 justify-content-center text-xl bold-text mb-2">Above</span>
        <span class="flex flex-grow-1 justify-content-center text-xl bold-text mb-2">Below</span>
        <span class="flex flex-grow-1 justify-content-center text-xl bold-text mb-2">Above</span>
        <span class="flex flex-grow-1 justify-content-center text-xl bold-text mb-2">Below</span>
      </div>
      <div class="flex flex-row gap-2 justify-content-end">
        <p-table
          [value]="dieselPositiveBandings"
          [paginator]="false"
          selectionMode="single"
          [loading]="loadingSettings"
        >
          <ng-template pTemplate="header">
            <tr>
              <th>Band</th>
              <th>Price (p)</th>
              <th>Surcharge (£)</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr>
              <td>{{ item.band }}</td>
              <td>{{ item.price | number : '1.2-2' }}</td>
              <td>{{ item.surcharge | number : '1.2-2' }}</td>
            </tr>
          </ng-template>
        </p-table>
        <p-table
          [value]="dieselNegativeBandings"
          [paginator]="false"
          selectionMode="single"
          [loading]="loadingSettings"
        >
          <ng-template pTemplate="header">
            <tr>
              <th>Band</th>
              <th>Price</th>
              <th>Surcharge (£)</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr>
              <td>{{ item.band }}</td>
              <td>{{ item.price | number : '1.2-2' }}</td>
              <td>{{ item.surcharge | number : '1.2-2' }}</td>
            </tr>
          </ng-template>
        </p-table>
        <p-table
          [value]="petrolPositiveBandings"
          [paginator]="false"
          selectionMode="single"
          [loading]="loadingSettings"
        >
          <ng-template pTemplate="header">
            <tr>
              <th>Band</th>
              <th>Price</th>
              <th>Surcharge (£)</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr>
              <td>{{ item.band }}</td>
              <td>{{ item.price | number : '1.2-2' }}</td>
              <td>{{ item.surcharge | number : '1.2-2' }}</td>
            </tr>
          </ng-template>
        </p-table>
        <p-table
          [value]="petrolNegativeBandings"
          [paginator]="false"
          selectionMode="single"
          [loading]="loadingSettings"
        >
          <ng-template pTemplate="header">
            <tr>
              <th>Band</th>
              <th>Price</th>
              <th>Surcharge (£)</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr>
              <td>{{ item.band }}</td>
              <td>{{ item.price | number : '1.2-2' }}</td>
              <td>{{ item.surcharge | number : '1.2-2' }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>
<div *ngIf="tab == 2" class="content-container">
  <div *ngIf="!loading" class="flex flex-column px-4 py-4 gap-4">
    <div class="flex flex-column gap-2">
      <span class="text-2xl bold-text mb-2">Fuel Price Adjuster Configuration</span>
      <div>
        <button
          pButton
          type="button"
          label="Edit"
          class="ui-button ui-button-default btn-to-right pull-right m-0 mr-2"
          (click)="openExcludedCustomersDialog()"
        ></button>
      </div>
      <p-table [value]="excludedCustomers" [paginator]="false" [loading]="loadingSettings">
        <ng-template pTemplate="header">
          <tr>
            <th>Excluded Customers</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td style="text-align: center; padding: 20px" [attr.colspan]="1">No customers found</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr>
            <td>{{ item }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<p-dialog
  header="Add Fuel Prices"
  [(visible)]="showAddFuelPricesDialog"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '600px' }"
  [contentStyle]="{ overflow: 'visible' }"
>
  <form [formGroup]="addFuelForm">
    <div class="ui-g">
      <div class="ui-g-6">
        <div class="input-label">Diesel Price (p/Litre)</div>
        <div class="input-value">
          <input
            pInputText
            required
            type="number"
            step="0.01"
            formControlName="dieselPrice"
            style="width: 100%"
          />
        </div>
      </div>
      <div class="ui-g-6">
        <div class="input-label">Petrol Price (p/Litre)</div>
        <div class="input-value">
          <input
            pInputText
            required
            type="number"
            step="0.01"
            formControlName="petrolPrice"
            style="width: 100%"
          />
        </div>
      </div>
      <div class="ui-g-12">
        <div class="input-label">Effective Date</div>
        <div class="input-value">
          <p-calendar
            formControlName="effectiveDate"
            dateFormat="dd/mm/yy"
            [style]="{ width: '100%' }"
            [inputStyle]="{ width: '100%' }"
            [maxDate]="maxDate"
          ></p-calendar>
        </div>
      </div>
    </div>
    <div class="d-flex w-100">
      <div class="flex-grow-1 text-right">
        <button
          pButton
          type="button"
          label="Cancel"
          class="ui-button ui-button-default"
          (click)="showAddFuelPricesDialog = false"
        ></button>
        <button
          pButton
          type="button"
          label="Save"
          [disabled]="!addFuelForm.valid"
          class="ui-button green-btn"
          (click)="saveFuelPrices()"
        ></button>
      </div>
    </div>
  </form>
</p-dialog>
<p-dialog
  header="Add Excluded Customers"
  [(visible)]="showExcludeCustomersDialog"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '600px' }"
  [contentStyle]="{ overflow: 'visible' }"
>
  <div class="ui-g">
    <div class="ui-g-12">
      <div class="input-label">Customers</div>
      <p-multiSelect
        [options]="customersOptions"
        [style]="{ width: '100%' }"
        defaultLabel="Select Customers"
        [(ngModel)]="selectedCustomerOptions"
      >
      </p-multiSelect>
    </div>
  </div>
  <div class="d-flex w-100">
    <div class="flex-grow-1 text-right">
      <button
        pButton
        type="button"
        label="Cancel"
        class="ui-button ui-button-default"
        (click)="showExcludeCustomersDialog = false"
      ></button>
      <button
        pButton
        type="button"
        label="Save"
        class="ui-button green-btn"
        (click)="saveExcludedCustomers()"
      ></button>
    </div>
  </div>
</p-dialog>
